module.exports = __webpack_public_path__ + "static/media/05_PickupPointUpdated.db2f30bd.jpg";